// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"13c3ed22","853":"680f4f51","935":"56abb802"}[chunkId] + ".chunk.js";
};